import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { useModal } from "../../../common_nextgen/hooks/ModalContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";


const useAlternateCopayPSCOverrides = () => {
  const [data, setData] = useState([]);

  const {
    ALTERNATE_COPAY_OVERRIDE_ADD,
    ALTERNATE_COPAY_OVERRIDE_EDIT,
    ALTERNATE_COPAY_OVERRIDE_DISPLAY,
    BENEFIT_ALT_COPAY_FORM_EDIT,
    BENEFIT_MAX_STEP_SCHEDULE_SEARCH,
  } = ROUTE_PATHS;
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  //const { bscScheduleName, bscDescription, bsdStepNumber, bmdScheduleCode, bmdDescription } = location.state || {};
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedPriceSchedules = [],
    previousScreen = BENEFIT_MAX_STEP_SCHEDULE_SEARCH,
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      bscScheduleName: selectedPriceSchedules[initialIndex].bscScheduleName,
      bscDescription: selectedPriceSchedules[initialIndex].bscDescription,
      bsdStepNumber: selectedPriceSchedules[initialIndex].bsdStepNumber,
      bmdScheduleCode: selectedPriceSchedules[initialIndex].bmdScheduleCode,
      bmdDescription: selectedPriceSchedules[initialIndex].bmdDescription,
    },
  } = currentState;
  const [paramsData, setParamsData] = useState(initialParamsData);
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const { axios_helper_no_header } = useAxios();

  const screen_title = "Alternate Copay PSC Overrides";
  const screenNumber = "RCACP001";

  const { showModal } = useModal();
  const showDrugStatusScheduleDetails = (formData) => {
    //console.log("schedule", schedule);
    showModal(
      { default: "RCBDD001" },
      {
        params: {
          fieldMapping: {
            default: [
              { source: "bmdScheduleCode", target: "bmdScheduleCode" },
              { source: "bmdDescription", target: "bmdDescription" },
            ],
          },
          lookupType: "local",
          viewType: "local",
        },
      },
      null,
      { ...formData },
      true
    );
  };

  const formFields = [
    {
      fieldLabel: "Benefit Max Schedule",
      name: "bscScheduleName",
      label: "Benefit Max Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "BSC Description",
      name: "bscDescription",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 30,
    },
    {
      fieldLabel: "Step",
      name: "bsdStepNumber",
      label: "Step",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 2,
    },
    {
      fieldLabel: "Benefit Max Drug Status Schedule",
      name: "bmdScheduleCode",
      label: "Benefit Max Drug Status Schedule",
      type: "link",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
      fieldHandler: showDrugStatusScheduleDetails,
    },
    {
      fieldLabel: "BMD Description",
      name: "bmdDescription",
      label: "Benefit Max Drug Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 30,
    },
  ];

  const dropdownOptions = [];

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (currentIndex < selectedPriceSchedules.length - 1) {
          setCurrentIndex((prevIndex) => prevIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];

  const ctaButtons = [
    {
      button_label: "Add Alternate Copay PSC Overrides",
      button_handeler: () => {
        console.log("cfdvfd", paramsData);
        navigateToPage(ALTERNATE_COPAY_OVERRIDE_ADD, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            previousScreen: location.pathname,
            paramsData: paramsData,
          },
        ]);
      },
      button_key: "F6",
    },

    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const menuOptions = [
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        // navigateToPage(ALTERNATE_COPAY_OVERRIDE_EDIT,
        //   {
        //     bscScheduleName: paramsData.bscScheduleName,
        //     bscDescription: paramsData.bscDescription,
        //     bsdStepNumber: paramsData.bsdStepNumber,
        //     bmdScheduleCode: paramsData.bmdScheduleCode,
        //     bmdDescription: paramsData.bmdDescription,
        //     acpMultiSourceCode: rowData.acpMultiSourceCode,
        //     acpProdSelCode: rowData.acpProdSelCode,
        //     previousScreen: location.pathname
        //   });

        navigateToPage(ALTERNATE_COPAY_OVERRIDE_EDIT, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            paramsData: paramsData,
            // acpMultiSourceCode: rowData.acpMultiSourceCode,
            // acpProdSelCode: rowData.acpProdSelCode,
            selectedPriceSchedules: selectedRows.length
              ? selectedRows
              : [rowData],
            previousScreen: location.pathname,
          },
        ]);
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        navigateToPage(ALTERNATE_COPAY_OVERRIDE_DISPLAY, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            paramsData: paramsData,
            // acpMultiSourceCode: rowData.acpMultiSourceCode,
            // acpProdSelCode: rowData.acpProdSelCode,
            selectedPriceSchedules: selectedRows.length
              ? selectedRows
              : [rowData],
            previousScreen: location.pathname,
          },
        ]);
      },
    },
    ,
  ];

  const columnDef = [
    { header: "PSC Code", field: "acpProdSelCode" },
    { header: "Multi Source Code", field: "acpMultiSourceCodeDescription" },
    { header: "Alternate Copay", field: "acpAlternateCopayDescription" },
  ];

  const parmKey = "bscScheduleName";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/altCopayPscOverride`,
        null,
        { page: page, size: rows, ...paramsData }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        response.map((obj) => {
          if (
            "acpAlternateCopay" in obj &&
            "acpAlternateCopayDescription" in obj
          ) {
            obj["acpAlternateCopayDescription"] =
              obj["acpAlternateCopay"] +
              "-" +
              obj["acpAlternateCopayDescription"];
          }
          if (
            "acpMultiSourceCode" in obj &&
            "acpMultiSourceCodeDescription" in obj
          ) {
            obj["acpMultiSourceCodeDescription"] =
              obj["acpMultiSourceCode"] +
              "-" +
              obj["acpMultiSourceCodeDescription"];
          }
        });
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData({
      dropDowns: dropdownOptions.map(
        (item) => item.field_label + item.condition
      ),
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage, currentIndex]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = {
        bscScheduleName: paramsData.bscScheduleName,
        bsdStepNumber: paramsData.bsdStepNumber,
        bmdScheduleCode: paramsData.bmdScheduleCode,
        acpProdSelCode: rowData.acpProdSelCode,
        acpMultiSourceCode: rowData.acpMultiSourceCode,
      };
      axios_helper_no_header("DELETE", "api/altCopayPscOverride", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const errorMessage =
            error.data?.responseStatus?.message || error.message;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: errorMessage,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/altCopayPscOverride/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deletePriceSchedule,
    setSelectedOption,
  };
};

export default useAlternateCopayPSCOverrides;
